import { render, staticRenderFns } from "./ChangeEntityOwner.vue?vue&type=template&id=aef406c6&scoped=true&"
import script from "./ChangeEntityOwner.vue?vue&type=script&lang=ts&"
export * from "./ChangeEntityOwner.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeEntityOwner.vue?vue&type=style&index=0&id=aef406c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef406c6",
  null
  
)

export default component.exports